import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { useFetchComments } from 'domain/comment'
import CommentTab from 'pages/building/buildingDetail/components/MenuRight/rn/CommentTab'
import { useRecoilState, useRecoilValue } from 'recoil'
import { selectedPoint, selectedPointDetail } from 'store/buildingStore'
import { currentOpenMenu } from 'store/displayToggleStore'
import currentViewerState from 'store/viewerStore'

import ShowBarIcon from 'components/icons/ShowBarIcon'

export default function ViewerRightBarRN() {
  const { id } = useParams()
  const selectedPointValue = useRecoilValue(selectedPoint)
  const pointDetail = useRecoilValue(selectedPointDetail)
  const currentViewer = useRecoilValue(currentViewerState)

  const activePointId = useMemo(() => {
    return (
      (currentViewer?.selectedPoint
        ? String(currentViewer.selectedPoint)
        : undefined) ||
      (selectedPointValue ? String(selectedPointValue) : undefined) ||
      (pointDetail?.id ? String(pointDetail.id) : undefined) ||
      ''
    )
  }, [currentViewer?.selectedPoint, selectedPointValue, pointDetail?.id])

  const { unresolvedCount } = useFetchComments({
    buildingId: id!,
    pointId: activePointId
  })

  const [{ isOpenRightMenu }, setIsOpenMenu] = useRecoilState(currentOpenMenu)

  const handleToggleRightSidebar = () => {
    setIsOpenMenu((prev) => ({ ...prev, isOpenRightMenu: !isOpenRightMenu }))
  }

  const handleCollapse = () => {
    setIsOpenMenu((prev) => ({ ...prev, isOpenRightMenu: false }))
  }

  const handleMouseDown = () => {
    const container = document.querySelector<HTMLElement>(
      '#viewer-building-container'
    )
    const rightSidebar = document.querySelector<HTMLElement>(
      '#viewer-building-right-sidebar'
    )
    const resize = (e: MouseEvent) => {
      const containerSize = container?.offsetWidth || window.innerWidth
      const size = containerSize - e.clientX - 60
      if (rightSidebar && size > 300 && size < 600) {
        rightSidebar.style.width = `${size}px`
      }
    }

    const stopResize = () => {
      window.removeEventListener('mousemove', resize)
      window.removeEventListener('mouseup', stopResize)
    }

    window.addEventListener('mousemove', resize)
    window.addEventListener('mouseup', stopResize)
  }

  return (
    <div className="absolute top-0 bottom-0 right-0 flex z-[700] select-none flex-row h-full">
      {/* Toggle Button */}
      <div
        className="absolute top-[10px] -left-10 cursor-pointer"
        onClick={handleToggleRightSidebar}
      >
        <ShowBarIcon className={!isOpenRightMenu ? '' : 'rotate-180'} />
      </div>

      {/* Slide-out Comment Panel */}
      {isOpenRightMenu && (
        <>
          <div
            className="w-[4px] cursor-ew-resize z-[600] relative h-full bg-[#FFF9E6]"
            style={{ borderLeft: '1px solid #EAD9A6' }}
            onMouseDown={handleMouseDown}
          >
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[2px] h-[19px] bg-[#CBB683] rounded-[20px]" />
          </div>
          <aside
            id="viewer-building-right-sidebar"
            className="panel-slide flex flex-none flex-col h-full bg-[#FFF9E6]"
            style={{
              width: '420px',
              borderLeft: '1px solid #EAD9A6'
            }}
          >
            <CommentTab handleCollapse={handleCollapse} />
          </aside>
        </>
      )}

      {/* Right Navigator Strip */}
      <div
        className="flex w-[60px] flex-none flex-col items-center border-l py-1.5 h-full"
        style={{
          backgroundColor: 'rgb(212, 154, 25)',
          borderColor: 'rgb(176, 129, 15)'
        }}
      >
        <button
          type="button"
          className={`relative mb-1 flex w-12 flex-col items-center gap-0.5 rounded-md py-1.5 transition border-0 bg-transparent outline-none focus:outline-none cursor-pointer ${
            isOpenRightMenu ? 'text-white' : 'hover:bg-black/10'
          }`}
          style={{
            backgroundColor: isOpenRightMenu ? 'rgb(100, 116, 139)' : undefined,
            color: isOpenRightMenu ? undefined : 'rgba(58, 46, 5, 0.72)'
          }}
          title="コメント"
          onClick={handleToggleRightSidebar}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-message-square-more"
          >
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            <path d="M8 10h.01" />
            <path d="M12 10h.01" />
            <path d="M16 10h.01" />
          </svg>
          <span className="text-[11px] font-bold leading-none whitespace-nowrap">
            コメント
          </span>
          {unresolvedCount > 0 && (
            <span
              className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-rose-500 px-1 text-[9px] font-bold text-white"
              style={{ boxShadow: '0 0 0 1.5px rgb(212, 154, 25)' }}
            >
              {unresolvedCount > 99 ? '99+' : unresolvedCount}
            </span>
          )}
        </button>
      </div>
    </div>
  )
}
